import { FEATURE_FLAGS } from '../constants/constants';

export interface NotificationResourceTypeDefinition {
  resourceType: string;
  preferenceFlag: FEATURE_FLAGS;
  titleTranslationKey: string;
  descriptionTranslationKey: string;
}

export const NOTIFICATION_RESOURCE_TYPES: readonly NotificationResourceTypeDefinition[] = [
  {
    resourceType: 'CAM_SPEC',
    preferenceFlag: FEATURE_FLAGS.CAM_SPEC_NOTIFICATIONS_ENABLED,
    titleTranslationKey: 'nafaCamSpecUpdatesTitleText',
    descriptionTranslationKey: 'nafaCamSpecUpdatesDescriptionText'
  }
];
